const application = {
	pageNotFound: "Side ikke funnet",
	toFrontpage: "Til forsiden"
} as const;

export default application;
